module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/faturamento/meu-faturamento.component.scss
// module id = ./src/app/modules/faturamento/meu-faturamento.component.scss
// module chunks = main